/**
 * @mixin
 */
module.exports = {
  props: {
    /** form数组
     * @values {form:[{label,value,showCondition,...}],title:"string",slot:""}
     * */
    formList: {
      type: Array,
      default: () => [],
      required: true,
    },
    /** 校验规则，同el-form的校验传参一致*/
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 请求详情的接口
     * @values detail
     * */
    api: {
      type: Object,
      default: () => {
        return {
          detail: null,
        };
      },
    },
    /** 提交之前对表单数据进行处理 */
    beforeSave: {
      type: Function,
      default: null,
    },
    /** 详情数据请求回来后进行处理 */
    afterGet: {
      type: Function,
      default: null,
    },
  },
};
